/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from 'js/utilities';

const languageSwitchNodes = Array.from(document.querySelectorAll('[data-language-switch]'));
if (languageSwitchNodes.length) {
    import(/* webpackChunkName: "LanguageSwitch" */ './components/LanguageSwitch').then(({ default: LanguageSwitch }) => {
        languageSwitchNodes.forEach((node) => render(<LanguageSwitch {...parseDataToProps(node.dataset)} />, node));
    });
}
